import { render, staticRenderFns } from "./OrderListTab.vue?vue&type=template&id=ef613a82&scoped=true&"
import script from "./OrderListTab.vue?vue&type=script&lang=js&"
export * from "./OrderListTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTab.vue?vue&type=style&index=0&id=ef613a82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef613a82",
  null
  
)

export default component.exports